import { z } from 'zod';

/**
 * Mirrors `backend/app/api/pagination.py`'s `Page[Item]`: a page of items plus the opaque
 * cursor that resumes after it. The cursor is base64url of a sort key with no signature - the
 * backend module is explicit that "clients must not build or parse one", so every caller in
 * this app treats `next_cursor` as a value to echo back verbatim, never to decode or construct.
 */
export function pageSchema<T extends z.ZodType>(item: T) {
  return z.object({
    items: z.array(item),
    next_cursor: z.string().nullable(),
  });
}

export type Page<T> = {
  readonly items: readonly T[];
  readonly next_cursor: string | null;
};
